import React from 'react';

export const UncoveredIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4V20C4 21.1046 4.89543 22 6 22H12.9995C11.7853 21.0878 11 19.6356 11 18C11 15.2386 13.2386 13 16 13C17.6356 13 19.0878 13.7853 20 14.9995V8L14 2H6C4.89543 2 4 2.89543 4 4ZM13 4V9H18L13 4ZM18.2673 21.1191L20.1481 23L21 22.1481L19.1191 20.2673C19.3625 19.963 19.5552 19.6131 19.6972 19.2176C19.8391 18.8221 19.9101 18.4013 19.9101 17.9551C19.9101 16.8497 19.5273 15.9141 18.7616 15.1485C17.996 14.3828 17.0604 14 15.9551 14C14.8497 14 13.9141 14.3828 13.1485 15.1485C12.3828 15.9141 12 16.8497 12 17.9551C12 19.0604 12.3828 19.996 13.1485 20.7616C13.9141 21.5273 14.8497 21.9101 15.9551 21.9101C16.4013 21.9101 16.8221 21.8391 17.2176 21.6972C17.6131 21.5552 17.963 21.3625 18.2673 21.1191ZM17.8946 19.8946C17.3621 20.427 16.7156 20.6932 15.9551 20.6932C15.1945 20.6932 14.548 20.427 14.0156 19.8946C13.4831 19.3621 13.2169 18.7156 13.2169 17.9551C13.2169 17.1945 13.4831 16.548 14.0156 16.0156C14.548 15.4831 15.1945 15.2169 15.9551 15.2169C16.7156 15.2169 17.3621 15.4831 17.8946 16.0156C18.427 16.548 18.6932 17.1945 18.6932 17.9551C18.6932 18.7156 18.427 19.3621 17.8946 19.8946Z"
        fill="#C4964D"
      />
    </svg>
  );
};
